var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtpPhone = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 185,
  viewBox: "0 0 120 185",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_18454_9820)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 18.5C12 9.66345 19.1634 2.5 28 2.5H92C100.837 2.5 108 9.66344 108 18.5V146.5C108 155.337 100.837 162.5 92 162.5H28C19.1634 162.5 12 155.337 12 146.5V18.5Z",
  fill: "url(#paint0_linear_18454_9820)",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_18454_9820)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 22.5C18 14.768 24.268 8.5 32 8.5H88C95.732 8.5 102 14.768 102 22.5V141.5C102 149.232 95.732 155.5 88 155.5H32C24.268 155.5 18 149.232 18 141.5V22.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.9923 14.0767C29.1713 14.0781 29.3502 14.1122 29.5292 14.179C29.7082 14.2457 29.8715 14.3565 30.0193 14.5114C30.167 14.6648 30.2856 14.8743 30.3751 15.1399C30.4646 15.4055 30.5093 15.7386 30.5093 16.1392C30.5093 16.527 30.4724 16.8714 30.3985 17.1726C30.3261 17.4723 30.221 17.7251 30.0832 17.9311C29.9468 18.1371 29.7806 18.2933 29.5846 18.3999C29.39 18.5064 29.1698 18.5597 28.9241 18.5597C28.6798 18.5597 28.4617 18.5114 28.27 18.4148C28.0796 18.3168 27.9234 18.1811 27.8012 18.0078C27.6805 17.8331 27.6031 17.6307 27.569 17.4006H28.0889C28.1357 17.6009 28.2288 17.7663 28.368 17.897C28.5086 18.0263 28.694 18.0909 28.9241 18.0909C29.2607 18.0909 29.5264 17.9439 29.721 17.6499C29.917 17.3558 30.015 16.9403 30.015 16.4034H29.9809C29.9014 16.5227 29.8069 16.6257 29.6975 16.7124C29.5882 16.799 29.4667 16.8658 29.3332 16.9126C29.1997 16.9595 29.0576 16.983 28.907 16.983C28.657 16.983 28.4276 16.9212 28.2188 16.7976C28.0115 16.6726 27.8453 16.5014 27.7203 16.2841C27.5967 16.0653 27.5349 15.8153 27.5349 15.5341C27.5349 15.267 27.5945 15.0227 27.7139 14.8011C27.8346 14.5781 28.0036 14.4006 28.221 14.2685C28.4397 14.1364 28.6968 14.0724 28.9923 14.0767ZM28.9923 14.5455C28.8133 14.5455 28.6521 14.5902 28.5086 14.6797C28.3666 14.7678 28.2536 14.8871 28.1698 15.0376C28.0874 15.1868 28.0463 15.3523 28.0463 15.5341C28.0463 15.7159 28.086 15.8814 28.1656 16.0305C28.2465 16.1783 28.3566 16.2962 28.4958 16.3842C28.6365 16.4709 28.7963 16.5142 28.9752 16.5142C29.1102 16.5142 29.2359 16.4879 29.3524 16.4354C29.4688 16.3814 29.5704 16.3082 29.657 16.2159C29.7451 16.1222 29.814 16.0163 29.8637 15.8984C29.9134 15.7791 29.9383 15.6548 29.9383 15.5256C29.9383 15.3551 29.8971 15.1953 29.8147 15.0462C29.7338 14.897 29.6215 14.7763 29.4781 14.6839C29.336 14.5916 29.1741 14.5455 28.9923 14.5455ZM31.9624 17.9418C31.8573 17.9418 31.7671 17.9041 31.6919 17.8288C31.6166 17.7536 31.5789 17.6634 31.5789 17.5582C31.5789 17.4531 31.6166 17.3629 31.6919 17.2876C31.7671 17.2124 31.8573 17.1747 31.9624 17.1747C32.0676 17.1747 32.1578 17.2124 32.233 17.2876C32.3083 17.3629 32.346 17.4531 32.346 17.5582C32.346 17.6278 32.3282 17.6918 32.2927 17.75C32.2586 17.8082 32.2124 17.8551 32.1542 17.8906C32.0974 17.9247 32.0335 17.9418 31.9624 17.9418ZM31.9624 15.7344C31.8573 15.7344 31.7671 15.6967 31.6919 15.6214C31.6166 15.5462 31.5789 15.456 31.5789 15.3509C31.5789 15.2457 31.6166 15.1555 31.6919 15.0803C31.7671 15.005 31.8573 14.9673 31.9624 14.9673C32.0676 14.9673 32.1578 15.005 32.233 15.0803C32.3083 15.1555 32.346 15.2457 32.346 15.3509C32.346 15.4205 32.3282 15.4844 32.2927 15.5426C32.2586 15.6009 32.2124 15.6477 32.1542 15.6832C32.0974 15.7173 32.0335 15.7344 31.9624 15.7344ZM33.3778 17.6051V17.1705L35.2954 14.1364H35.6107V14.8097H35.3976L33.9488 17.1023V17.1364H36.5312V17.6051H33.3778ZM35.4317 18.5V17.473V17.2706V14.1364H35.9346V18.5H35.4317ZM39.0454 14.1364V18.5H38.517V14.6903H38.4914L37.426 15.3977V14.8608L38.517 14.1364H39.0454Z",
  fill: "#0A0A0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 37.5C48 33.0817 51.5817 29.5 56 29.5H64C68.4183 29.5 72 33.0817 72 37.5V45.5C72 49.9183 68.4183 53.5 64 53.5H56C51.5817 53.5 48 49.9183 48 45.5V37.5Z",
  fill: "#2B7FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 65.5C26 63.2909 27.7909 61.5 30 61.5H90C92.2091 61.5 94 63.2909 94 65.5V87.5C94 89.7091 92.2091 91.5 90 91.5H30C27.7909 91.5 26 89.7091 26 87.5V65.5Z",
  fill: "#EFF6FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.0078 70.8828C32.0078 69.0145 33.5223 67.5 35.3906 67.5C37.2589 67.5 38.7734 69.0145 38.7734 70.8828V76.1172C38.7734 77.9855 37.2589 79.5 35.3906 79.5C33.5223 79.5 32.0078 77.9855 32.0078 76.1172V70.8828Z",
  fill: "#1E2939"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7734 70.8828C40.7734 69.0145 42.288 67.5 44.1562 67.5C46.0245 67.5 47.5391 69.0145 47.5391 70.8828V76.1172C47.5391 77.9855 46.0245 79.5 44.1562 79.5C42.288 79.5 40.7734 77.9855 40.7734 76.1172V70.8828Z",
  fill: "#1E2939"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.5391 70.8828C49.5391 69.0145 51.0536 67.5 52.9219 67.5C54.7902 67.5 56.3047 69.0145 56.3047 70.8828V76.1172C56.3047 77.9855 54.7902 79.5 52.9219 79.5C51.0536 79.5 49.5391 77.9855 49.5391 76.1172V70.8828Z",
  fill: "#1E2939"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.6875 70.8828C63.6875 69.0145 65.202 67.5 67.0703 67.5C68.9386 67.5 70.4531 69.0145 70.4531 70.8828V76.1172C70.4531 77.9855 68.9386 79.5 67.0703 79.5C65.202 79.5 63.6875 77.9855 63.6875 76.1172V70.8828Z",
  fill: "#1E2939"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.4531 70.8828C72.4531 69.0145 73.9677 67.5 75.8359 67.5C77.7042 67.5 79.2188 69.0145 79.2188 70.8828V76.1172C79.2188 77.9855 77.7042 79.5 75.8359 79.5C73.9677 79.5 72.4531 77.9855 72.4531 76.1172V70.8828Z",
  fill: "#1E2939"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.2188 70.8828C81.2188 69.0145 82.7333 67.5 84.6016 67.5C86.4698 67.5 87.9844 69.0145 87.9844 70.8828V76.1172C87.9844 77.9855 86.4698 79.5 84.6016 79.5C82.7333 79.5 81.2188 77.9855 81.2188 76.1172V70.8828Z",
  fill: "#1E2939"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 84.5C44 83.9477 44.4477 83.5 45 83.5H75C75.5523 83.5 76 83.9477 76 84.5C76 85.0523 75.5523 85.5 75 85.5H45C44.4477 85.5 44 85.0523 44 84.5Z",
  fill: "#2B7FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 99.5C26 97.2909 27.7909 95.5 30 95.5H90C92.2091 95.5 94 97.2909 94 99.5V115.5C94 117.709 92.2091 119.5 90 119.5H30C27.7909 119.5 26 117.709 26 115.5V99.5Z",
  fill: "#F3F4F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 127.5C26 125.291 27.7909 123.5 30 123.5H90C92.2091 123.5 94 125.291 94 127.5V143.5C94 145.709 92.2091 147.5 90 147.5H30C27.7909 147.5 26 145.709 26 143.5V127.5Z",
  fill: "#F3F4F6"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd_18454_9820",
  x: 0,
  y: 0.5,
  width: 120,
  height: 184,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 4,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow_18454_9820"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_18454_9820"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 3,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect2_dropShadow_18454_9820"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_18454_9820",
  result: "effect2_dropShadow_18454_9820"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_18454_9820",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18454_9820",
  x1: 60,
  y1: 2.5,
  x2: 60,
  y2: 162.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1E2939"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101828"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_18454_9820"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 22.5C18 14.768 24.268 8.5 32 8.5H88C95.732 8.5 102 14.768 102 22.5V141.5C102 149.232 95.732 155.5 88 155.5H32C24.268 155.5 18 149.232 18 141.5V22.5Z",
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtpPhone);
export default ForwardRef;